import {Pipe, PipeTransform} from '@angular/core';
import {IClinicalObjective} from '../../models/clinic';

@Pipe({
  name: 'setClinicalObjectiveColor'
})
export class SetClinicalObjectiveColorPipe implements PipeTransform {

  transform(value: IClinicalObjective): string {
    let color;
    switch (value.value) {
      case 'loseWeight':
        color = '#f3a683';
        break;
      case 'gainWeight':
        color = '#778beb';
        break;
      case 'toneBody':
        color = '#cf6a87';
        break;
      case 'diseaseTreatment':
        color = '#786fa6';
        break;
    }
    return color;
  }
}
